import { buildAnnotationDedupeKey, type AiProposalBridgeContext, annotationFrameIndex, formatAnnotationTimecode } from "@/ai/context/buildContext";
import type { AiAnnotationDraft } from "@/ai/engines/engine.types";
import { AI_ANNOTATION_SUBTYPES, buildAiAnnotationRecord } from "@/components/OmniCine/Annotations/annotationAiSchema";
import type { TimelineAnnotation } from "@/state/timeline/timeline.types";

export function normalizeAiAnnotation(
  draft: AiAnnotationDraft,
  context: AiProposalBridgeContext,
  seenKeys: Set<string>,
): TimelineAnnotation | null {
  const allowedSubtypes = AI_ANNOTATION_SUBTYPES[draft.type] ?? [];
  if (!allowedSubtypes.includes(draft.subtype)) return null;

  const timeSec = typeof draft.timeSec === "number" && Number.isFinite(draft.timeSec)
    ? Math.max(0, draft.timeSec)
    : context.anchorTimeSec;
  const frame = Number.isFinite(draft.frame) ? Math.max(0, Math.floor(Number(draft.frame))) : annotationFrameIndex(timeSec, context.fps);
  const assetLabel = String(draft.assetLabel ?? context.selectedClipLabel).trim() || context.selectedClipLabel;
  const dedupeKey = draft.dedupeKey ?? buildAnnotationDedupeKey({
    nodeId: draft.nodeId,
    subtype: draft.subtype,
    frameIndex: frame,
    assetLabel,
  });

  if (seenKeys.has(dedupeKey)) return null;
  seenKeys.add(dedupeKey);

  return buildAiAnnotationRecord({
    createdAt: context.now,
    nodeId: draft.nodeId ?? null,
    frame,
    timeSec,
    type: draft.type,
    subtype: draft.subtype,
    severity: draft.severity,
    summary: draft.summary.trim(),
    details: draft.details,
    proposedAction: draft.proposedAction,
    assetLabel,
    anchorTimecode: formatAnnotationTimecode(timeSec, context.fps),
    clipId: draft.clipId ?? context.selectedClipId,
    linkedAudio: draft.linkedAudio ?? context.linkedAudio,
    action: draft.action ?? null,
    source: draft.source ?? "ai",
  });
}